export const LEGISGRAPH_METRICS = [
  { key: 'nodes', value: '> 5.3M' },
  { key: 'relationships', value: '> 8.7M' },
  { key: 'judgments', value: '> 4M' },
  { key: 'acts', value: '193,000+' },
] as const;
